var map = {
	"./alexandrite_30 Background Removed.png": 5997,
	"./almandine_15 Background Removed.png": 9934,
	"./amazonite_21 Background Removed.png": 3122,
	"./amber_25 Background Removed.png": 1087,
	"./amber_26 Background Removed.png": 1830,
	"./amethyst_0 Background Removed.png": 9258,
	"./ametrine_11 Background Removed.png": 4090,
	"./ametrine_34 Background Removed.png": 6851,
	"./ametrine_35 Background Removed.png": 4592,
	"./andalusite_28 Background Removed.png": 9455,
	"./andalusite_35 Background Removed.png": 3109,
	"./andradite_18 Background Removed.png": 8146,
	"./aquamarine_36 Background Removed.png": 3098,
	"./aventurine green_2 Background Removed.png": 4779,
	"./aventurine green_48 Background Removed.png": 6069,
	"./benitoite_0 Background Removed.png": 5576,
	"./benitoite_24 Background Removed.png": 236,
	"./beryl golden_5 Background Removed.png": 9863,
	"./bixbite_13 Background Removed.png": 9888,
	"./bloodstone_12 Background Removed.png": 5681,
	"./bloodstone_4 Background Removed.png": 6920,
	"./cats eye_2 Background Removed.png": 5679,
	"./cats eye_6 Background Removed.png": 2091,
	"./chalcedony blue_0 Background Removed.png": 7949,
	"./chalcedony blue_27 Background Removed.png": 4014,
	"./chalcedony_31 Background Removed.png": 2063,
	"./chrome diopside_34 Background Removed.png": 5899,
	"./chrysocolla_3 Background Removed.png": 3855,
	"./chrysoprase_33 Background Removed.png": 5942,
	"./citrine_22 Background Removed.png": 3343,
	"./coral_10 Background Removed.png": 1145,
	"./coral_28 Background Removed.png": 5130,
	"./coral_29 Background Removed.png": 5797,
	"./danburite_31 Background Removed.png": 3755,
	"./danburite_35 Background Removed.png": 2111,
	"./diamond_33 Background Removed.png": 9929,
	"./dumortierite_14 Background Removed.png": 1439,
	"./dumortierite_18 Background Removed.png": 6691,
	"./dumortierite_22 Background Removed.png": 8682,
	"./emerald_26 Background Removed.png": 375,
	"./emerald_34 Background Removed.png": 7976,
	"./emerald_39 Background Removed.png": 9671,
	"./garnet red_35 Background Removed.png": 715,
	"./iolite_17 Background Removed.png": 8393,
	"./iolite_28 Background Removed.png": 6515,
	"./malachite_8 Background Removed.png": 1653,
	"./onyx green_30 Background Removed.png": 6707,
	"./onyx green_31 Background Removed.png": 7472,
	"./quartz lemon_33 Background Removed.png": 4223,
	"./rhodonite_27 Background Removed.png": 2300,
	"./sapphire pink_8 Background Removed.png": 9,
	"./spessartite_33 Background Removed.png": 200,
	"./spinel_19 Background Removed.png": 112,
	"./tanzanite_8 Background Removed.png": 8491,
	"./zoisite_22 Background Removed.png": 5804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2925;